module.exports = __webpack_public_path__ + "img/keypal-2.33bd3b64.png";